import React from "react";

import {
  BlockStack,
  Box,
  Button,
  Card,
  Divider,
  InlineGrid,
  InlineStack,
  Text,
} from "@shopify/polaris";

export function AccountInformation({ client, handleEditAccountDetails }) {
  return (
    <>
      <Card padding="0">
        <Box padding="400">
          <InlineStack align="space-between">
            <Text variant="headingMd" as="h2">
              Account information
            </Text>
            <Button onClick={() => handleEditAccountDetails()} variant="plain">
              Edit client
            </Button>
          </InlineStack>
        </Box>
        <Box padding="400" paddingBlockStart="0">
          <InlineGrid columns={4} gap="2">
            <BlockStack gap="100">
              <Text as="label">Legal name</Text>
              <Text as="p">{client.attributes.name}</Text>
            </BlockStack>
            <BlockStack gap="100">
              <Text as="label">DBA</Text>
              <Text as="p">{client.attributes.dba || "-"}</Text>
            </BlockStack>
            <BlockStack gap="100">
              <Text as="label">Email</Text>
              <Text as="p">{client.attributes.email || "-"}</Text>
            </BlockStack>
            <BlockStack gap="100">
              <Text as="label">Phone number</Text>
              <Text as="p">{client.attributes.phone || "-"}</Text>
            </BlockStack>
          </InlineGrid>
        </Box>

        {/* PROD-34 */}
        <Box padding="400" paddingBlockStart="0">
          <InlineGrid columns={4} gap="2">
            <BlockStack gap="100">
              <Text as="label">EIN</Text>
              <Text as="p">{client.attributes.ein || "-"}</Text>
            </BlockStack>
            <BlockStack gap="100">
              <Text as="label">Corporation Type</Text>
              <Text as="p">
                {client.attributes.opencorporates_company_type || "-"}
              </Text>
            </BlockStack>
            <BlockStack gap="100">
              <Text as="label">Date Established</Text>
              <Text as="p">
                {client.attributes.opencorporates_incorporation_date || "-"}
              </Text>
            </BlockStack>
            <BlockStack gap="100">
              <Text as="label">Industry</Text>
              <Text as="p">{"-"}</Text>
            </BlockStack>
          </InlineGrid>
        </Box>

        <Box padding="400" paddingBlockStart="0">
          <InlineGrid columns={4} gap="2">
            <BlockStack gap="100">
              <Text as="label">Employee Count</Text>
              <Text as="p">{"-"}</Text>
            </BlockStack>
            <BlockStack gap="100">
              <Text as="label">Revenues</Text>
              <Text as="p">{"-"}</Text>
            </BlockStack>
            <BlockStack gap="100">
              <Text as="label">URL</Text>
              <Text as="p">{"-"}</Text>
            </BlockStack>
            <BlockStack gap="100">
              <Text as="label">DUNS</Text>
              <Text as="p">{"-"}</Text>
            </BlockStack>
          </InlineGrid>
        </Box>

        <Divider borderColor="border" />

        <Box padding="400">
          <BlockStack gap="100">
            <Text as="label">Street address</Text>
            <Text as="p">{client.attributes.billing_street || "-"}</Text>
            <InlineGrid columns={3} gap="2">
              <BlockStack gap="100">
                <Text as="label">City</Text>
                <Text as="p">{client.attributes.billing_city || "-"}</Text>
              </BlockStack>
              <BlockStack gap="100">
                <Text as="label">State</Text>
                <Text as="p">{client.attributes.billing_state || "-"}</Text>
              </BlockStack>
              <BlockStack gap="100">
                <Text as="label">Zip code</Text>
                <Text as="p">
                  {client.attributes.billing_postal_code || "-"}
                </Text>
              </BlockStack>
            </InlineGrid>
          </BlockStack>
        </Box>
      </Card>
    </>
  );
}
